import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=db842e6c&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db842e6c')) {
      api.createRecord('db842e6c', component.options)
    } else {
      api.reload('db842e6c', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=db842e6c&", function () {
      api.rerender('db842e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cS0i7i8aCvJ2/JS/CurrentYear.vue"
export default component.exports